import type { RobisFormConfig } from '#types/config/components/form/robis'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    cta: 'mt-6',
    form: '',
    heading: 'title-3',
    inputsWrapper: 'mb-6 mt-4 space-y-4'
  },
} satisfies RecursivePartial<RobisFormConfig>
